import { render, staticRenderFns } from "./SubContent.vue?vue&type=template&id=a7d66a38&scoped=true"
import script from "./SubContent.vue?vue&type=script&lang=js"
export * from "./SubContent.vue?vue&type=script&lang=js"
import style0 from "./SubContent.vue?vue&type=style&index=0&id=a7d66a38&prod&lang=stylus&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7d66a38",
  null
  
)

export default component.exports